import { firstBusinessDay, lastBusinessDay } from '../constants';
import { isHoliday, isWeekend } from './dates';
export function getFirstOrLastBusinessDay(_a) {
    var federalHolidays = _a.federalHolidays, date = _a.date, frequency = _a.frequency;
    var getFirstBusinessDay = function (d) {
        var day = d.startOf('month');
        while (isHoliday(day, federalHolidays) || isWeekend(day)) {
            day = day.add(1, 'day');
        }
        return day;
    };
    var getLastBusinessDay = function (d) {
        var day = d.endOf('month');
        while (isHoliday(day, federalHolidays) || isWeekend(day)) {
            day = day.subtract(1, 'day');
        }
        return day;
    };
    switch (frequency) {
        case firstBusinessDay:
            return getFirstBusinessDay(date);
        case lastBusinessDay:
            return getLastBusinessDay(date);
        default:
            throw new Error('Only the firstBusinessDay or lastBusinessDay frequencies should be passed to getFirstOrLastBusinessDay');
    }
}
export default getFirstOrLastBusinessDay;
//# sourceMappingURL=getFirstOrLastBusinessDay.js.map